// extracted by mini-css-extract-plugin
export default {"bgBlock":"Preview__bgBlock___289x0","listAnswer":"Preview__listAnswer___3FAzR","listSubHeader":"Preview__listSubHeader___3umLm"};